import { useLocalStorage } from "@mantine/hooks"

export function useReferral() {
  return useLocalStorage<string>({ key: "referral", defaultValue: "/" })
}
